import { render } from "./CoursePreview.vue?vue&type=template&id=a850adec"
import script from "./CoursePreview.vue?vue&type=script&lang=js"
export * from "./CoursePreview.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__